import { render, staticRenderFns } from "./AngleSelector.vue?vue&type=template&id=80fb53f0&"
import script from "./AngleSelector.vue?vue&type=script&lang=ts&"
export * from "./AngleSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports